import { render, staticRenderFns } from "./GoodReceiptList.vue?vue&type=template&id=144669a2"
import script from "./GoodReceiptList.vue?vue&type=script&lang=js"
export * from "./GoodReceiptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports